

































































import BpcWipayTicket from '@payment-terminals/components/wipay-ticket/wipay-ticket.vue';
import { POSTicketDetail } from '@pos/interfaces/pos-v2';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import BpcPosPaymentBalanceDetails from './pos-payment-balance-details.vue';
import BpcPosTerminalSelector from '@pos/components/v2/pos-terminal-selector.vue';
import { WipayPaymentMethod, WipayTicketPrintArray } from '@payment-terminals/interfaces/wipay';

@Component({
  name: 'bpc-pos-wipay-payment-modal',
  components: {
    BpcWipayTicket,
    BpcPosPaymentBalanceDetails,
    BpcPosTerminalSelector,
  },
})
export default class PosWipayPaymentModal extends Vue {
  // PROPS
  @Prop({ type: String, required: true })
  readonly paymentMethod: WipayPaymentMethod;
  @Prop({ type: Boolean, default: false }) readonly loading: boolean;
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: Boolean, default: false }) readonly closeDisabled: boolean;
  @Prop({
    type: Number,
    required: true,
  })
  readonly amountToBePaid!: number;
  @Prop({
    type: Number,
    required: true,
  })
  readonly paymentAmount!: number;
  @Prop({
    type: Number,
    required: true,
  })
  readonly posSessionId!: number;
  @Prop({ type: Object, required: true }) readonly ticketDetail: POSTicketDetail;

  @Prop({ type: String, required: true }) modalTitle: string;

  @Prop({
    type: Number,
    required: true,
  })
  readonly contactId!: number;
  @Prop({
    type: Boolean,
  })
  readonly showTerminalTicket: boolean;

  // DATA
  selectedPaymentTerminalId: number = null;
  showUpdatePaymentStatusButton = false;
  paymentStatusVariant = '';
  paymentStatusMessage = '';
  showPaymentStatusInfo = false;
  confirmDisabled = true;
  hideConfirmButton = false;
  savingPayment = false;
  showWipayTicket = false;
  wipayTicket: WipayTicketPrintArray = [];
  refreshInterval: number = null;

  // Computed
  get terminalType(): string {
    return 'wipay';
  }

  destroyed() {
    this.$posService.leaveTerminalPaymentChannel(
      this.posSessionId,
      this.ticketDetail.id,
      this.paymentMethod,
    );
    clearInterval(this.refreshInterval);
  }

  closeModal() {
    this.$emit('close');
  }

  async sendToTerminal() {
    this.savingPayment = true;
    this.showWipayTicket = false;
    this.showPaymentStatusInfo = false;

    const ticket = await this.$posService.createPayment(
      this.posSessionId,
      this.ticketDetail.id,
      this.paymentAmount,
      this.paymentMethod,
      this.contactId,
      this.selectedPaymentTerminalId,
    );

    this.$emit('ticket-detail-updated', ticket);
    this.showUpdatePaymentStatusButton = true;
    this.confirmDisabled = true;
    this.listenToPaymentEvents();
    this.updateStatusAndTryAgainAfterTimeout();
  }

  async updateStatusAndTryAgainAfterTimeout() {
    this.refreshInterval = setInterval(async () => {
      if (
        this.showModal &&
        this.showUpdatePaymentStatusButton &&
        this.ticketDetail.status === 'to_pay'
      ) {
        await this.updateTerminalPaymentStatus();
        // await this.updateStatusAndTryAgainAfterTimeout();
      } else {
        clearInterval(this.refreshInterval);
      }
    }, 8000);
  }

  listenToPaymentEvents() {
    const paymentEventsListener = this.$posService.listenPaymentEvents(
      this.posSessionId,
      this.ticketDetail.id,
      this.paymentMethod,
    );

    if (paymentEventsListener) {
      paymentEventsListener
        .listen('.BPC\\PaymentTerminals\\Events\\TerminalPaymentCancelled', async data => {
          // console.log('getTerminalPaymentChannel listen event', data);
          const paymentInArray = this.ticketDetail.payments.find(
            payment => payment.id === data.paymentId,
          );
          if (paymentInArray) {
            this.$emit('payment-cancelled');
            this.savingPayment = false;
            this.showWipayTicket = false;

            this.showpaymentStatusMessage(
              'warning',
              'payment_terminals.modal.payment_status_cancelled',
            );
          }
        })
        .listen('.BPC\\PaymentTerminals\\Events\\TerminalPaymentConfirmed', async data => {
          console.log('getTerminalPaymentChannel listen event', data);
          const paymentInArray = this.ticketDetail.payments.find(
            payment => payment.id === data.paymentId,
          );
          if (paymentInArray) {
            this.$emit('success-payment');

            this.savingPayment = false;
            this.hideConfirmButton = true;
            this.wipayTicket = data?.terminalTicket || null;
            this.showWipayTicket = true;
            this.showpaymentStatusMessage(
              'success',
              'payment_terminals.modal.payment_status_approved',
            );
            if (!this.showTerminalTicket) {
              this.closeModal();
            }
          }
        })
        .listen('.BPC\\PaymentTerminals\\Events\\TerminalPaymentBusy', data => {
          const paymentInArray = this.ticketDetail.payments.find(
            payment => payment.id === data.paymentId,
          );
          if (paymentInArray) {
            this.showWipayTicket = false;

            this.showpaymentStatusMessage(
              'info',
              'payment_terminals.modal.payment_status_still_busy',
            );
          }
        });
    }
  }

  async updateTerminalPaymentStatus() {
    this.showWipayTicket = false;
    const lastPaymentId = this.ticketDetail.payments[this.ticketDetail.payments.length - 1].id;

    const ticketDetail = await this.$posService.updateTerminalPaymentStatus(
      this.posSessionId,
      this.ticketDetail.id,
      lastPaymentId,
    );

    this.$emit('ticket-detail-updated', ticketDetail);
  }

  showpaymentStatusMessage(variant, message) {
    this.paymentStatusVariant = variant;
    this.paymentStatusMessage = message;
    this.showPaymentStatusInfo = true;
  }

  @Watch('selectedPaymentTerminalId')
  onSelectedPaymentTerminalIdChanged(newTerminalId: number) {
    if (newTerminalId) {
      this.confirmDisabled = false;
    } else {
      this.confirmDisabled = true;
    }
  }

  @Watch('showModal')
  onShowModalChanged(newShowModal: boolean) {
    if (newShowModal) {
      this.selectedPaymentTerminalId = null;
      this.confirmDisabled = true;
      this.showUpdatePaymentStatusButton = false;
      this.paymentStatusVariant = '';
      this.paymentStatusMessage = '';
      this.showPaymentStatusInfo = false;
      this.hideConfirmButton = false;
      this.savingPayment = false;
      this.showWipayTicket = false;
      this.wipayTicket = [];
    }
  }
}
